<template>
    <div id="map"></div>
</template>

<script>
import mapboxgl from "mapbox-gl"
import 'mapbox-gl/dist/mapbox-gl.css'
import SitePopup from '@/components/map-popups/SitePopup.vue'
import Vue from 'vue'
var SitePopupComponent = Vue.extend(SitePopup)


let markers = []

export default {
    name: 'ResultsMap',
    components: {
    },
    props: {
        locations: {
            type: Array,
            required: true,
            default() {
                return []
            }
        },
        focusedMarker: {
            type: Number,
            default() {
                return null
            }
        },
        scrollZoom: {
            type: Boolean,
            default() {
                return true
            }
        },
        mapOptions: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
            mapStyle: process.env.VUE_APP_MAPBOX_MAP_STYLE,
            mapDefaults: {
                padding: 100,
                maxZoom: 14,
            }
        }
    },
    computed: {
        computedMapOptions() {
            return {...this.mapDefaults, ...this.mapOptions}
        }
    },
    watch: {
        locations() {
            this.setMarkers()
        },
        focusedMarker(newVal, oldVal) {
            this.hoverMarkerForId(newVal, oldVal)
        },
    },
    methods: {
        setMarkers() {
            markers.forEach(marker => marker.glMarker.remove())
            markers = []
            let bounds = new mapboxgl.LngLatBounds()
            
            this.locations.forEach(site => {
                let marker = new mapboxgl
                    .Marker({color: site.coming_soon ? '#999999' : '#FF7964', scale: 0.5})
                    .setLngLat([site.location.coords.lon, site.location.coords.lat])
                    .addTo(this.map)
                    .setPopup(this.popupForSite(site))
                markers.push({siteId: site.id, glMarker: marker})
                bounds.extend([site.location.coords.lon, site.location.coords.lat]);
            })
            
            if (!bounds.isEmpty()) {
                this.map.fitBounds(bounds, {
                    padding: { top: this.computedMapOptions.padding, bottom: this.computedMapOptions.padding, left: this.computedMapOptions.padding, right: this.computedMapOptions.padding },
                    duration: 500,
                    maxZoom: this.computedMapOptions.maxZoom,
                });
            }
        },
        hoverMarkerForId(siteId, oldSiteId = null) {
            if (oldSiteId) {
                let marker = this.findMarkerForId(oldSiteId)
                let site = this.findSiteForId(oldSiteId)
                this.setColorForMarker(marker, site.coming_soon ? '#999999' : '#FF7964', site)
            }
            if (siteId) {
                let marker = this.findMarkerForId(siteId)
                let site = this.findSiteForId(siteId)
                this.setColorForMarker(marker, 'black', site)
            }
        },
        findSiteForId(siteId) {
            return this.locations.find(site => site.id == siteId)
        },
        findMarkerForId(siteId) {
            return markers.find(marker => marker.siteId == siteId)
        },
        setColorForMarker(marker, color, site) {
            if (marker) {
                let newMarker = new mapboxgl
                    .Marker({color: color, scale: 0.5})
                    .setLngLat(marker.glMarker._lngLat)
                    .addTo(this.map)
                    .setPopup(this.popupForSite(site))
                marker.glMarker.remove()
                marker.glMarker = newMarker
            }
        },
        popupForSite(site) {
            let instance = new SitePopupComponent({
                propsData: { site: site }
            })
            instance.$mount()
            let markerHeight = 16
            let linearOffset = 0
            
            return new mapboxgl
                .Popup({
                    offset: {
                        'top': [0, -markerHeight],
                        'top-left': [0, -markerHeight],
                        'top-right': [0, -markerHeight],
                        'bottom': [0, -markerHeight],
                        'bottom-left': [linearOffset, -markerHeight],
                        'bottom-right': [-linearOffset, -markerHeight],
                        'left': [linearOffset, -markerHeight],
                        'right': [-linearOffset, -markerHeight]
                    },
                    closeButton: false,
                    maxWidth: '280px',
                })
                .setHTML(instance.$el.outerHTML);
        }
    },
    mounted() {
        mapboxgl.accessToken = this.accessToken
        this.map = new mapboxgl.Map({
            container: 'map',
            style: this.mapStyle,
            center: [-116.5, 39],
            zoom: 7,
            ...this.computedMapOptions,
        });
        
        this.map.addControl(new mapboxgl.NavigationControl());
        if (!this.scrollZoom) {
            this.map.scrollZoom.disable();
        }
        
        this.setMarkers()
    }
};
</script>

<style lang="scss"></style>